module.exports = __webpack_public_path__ + "static/media/ba-min.e3123823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/ba-min.svg
// module id = 678
// module chunks = 0